import { render, staticRenderFns } from "./Competences.vue?vue&type=template&id=1c58e5e4&scoped=true"
import script from "./Competences.vue?vue&type=script&lang=js"
export * from "./Competences.vue?vue&type=script&lang=js"
import style0 from "./Competences.vue?vue&type=style&index=0&id=1c58e5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c58e5e4",
  null
  
)

export default component.exports